<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      this.$emit('setpage', 9 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      this.loading = false;
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Professional Photography.png')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Property photos</h3>
        <p class="text-muted" data-aos="fade-zoom-in">In this section you can upload and arrange any property photos you have. If you have purchased or plan to purchase our professional photography service or a package including this service you can skip this section.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
